import { defineMessages } from 'react-intl';

// https://www.w3.org/TR/wai-aria/roles
export const AriaRoles = Object.freeze({
  ALERT: 'alert',
  ALERTDIALOG: 'alertdialog',
  ARTICLE: 'article',
  APPLICATION: 'application',
  BANNER: 'banner',
  BUTTON: 'button',
  CHECKBOX: 'checkbox',
  COLUMNHEADER: 'columnheader',
  COMPLEMENTARY: 'complementary',
  CONTENTINFO: 'contentinfo',
  COMBOBOX: 'combobox',
  DEFINITION: 'definition',
  DIALOG: 'dialog',
  DOCUMENT: 'document',
  DIRECTORY: 'directory',
  FORM: 'form',
  GRID: 'grid',
  GRIDCELL: 'gridcell',
  GROUP: 'group',
  HEADING: 'heading',
  IMG: 'img',
  LINK: 'link',
  LIST: 'list',
  LISTBOX: 'listbox',
  LISTITEM: 'listitem',
  LOG: 'log',
  MAIN: 'main',
  MARQUEE: 'marquee',
  MATH: 'math',
  MENU: 'menu',
  MENUBAR: 'menubar',
  MENUITEM: 'menuitem',
  MENUITEMCHECKBOX: 'menuitemcheckbox',
  MENUITEMRADIO: 'menuitemradio',
  NAVIGATION: 'navigation',
  NONE: 'none',
  NOTE: 'note',
  OPTION: 'option',
  PRESENTATION: 'presentation',
  PROGRESSBAR: 'progressbar',
  RADIOGROUP: 'radiogroup',
  RADIO: 'radio',
  REGION: 'region',
  ROW: 'row',
  ROWGROUP: 'rowgroup',
  ROWHEADER: 'rowheader',
  SCROLLBAR: 'scrollbar',
  SEARCH: 'search',
  SEPARATOR: 'separator',
  SLIDER: 'slider',
  SPINBUTTON: 'spinbutton',
  STATUS: 'status',
  SUBMENU: 'submenu',
  SWITCH: 'switch',
  TAB: 'tab',
  TABLIST: 'tablist',
  TABPANEL: 'tabpanel',
  TEXTBOX: 'textbox',
  TIMER: 'timer',
  TOOLBAR: 'toolbar',
  TOOLTIP: 'tooltip',
  TREE: 'tree',
  TREEGRID: 'treegrid',
  TREEITEM: 'treeitem',
});

export const AriaAttributes = Object.freeze({
  DESCRIBEDBY: 'aria-describedby',
  CHECKED: 'aria-checked',
  DISABLED: 'aria-disabled',
  LABELLEDBY: 'aria-labelledby',
  LABEL: 'aria-label',
  HIDDEN: 'aria-hidden',
  EXPANDED: 'aria-expanded',
  LIVE: 'aria-live',
  AUTOCOMPLETE: 'aria-autocomplete',
  HASPOPUP: 'aria-haspopup',
  INVALID: 'aria-invalid',
  ATOMIC: 'aria-atomic',
  VALUEMAX: 'aria-valuemax',
  VALUEMIN: 'aria-valuemin',
  VALUENOW: 'aria-valuenow',
  VALUETEXT: 'aria-valuetext',
});

export const messages = defineMessages({
  pandoraLogo: {
    id: 't.pandoraLogo',
    defaultMessage: 'Pandora - Home',
  },
  emailClearLogo: {
    id: 't.emailClearLogo',
    defaultMessage: 'clear textbox',
  },
  tunerBarScreenReaderText: {
    id: 't.tunerBarScreenReaderText',
    defaultMessage: 'Tuner bar',
  },
  sourceCardTrapScreenReaderText: {
    id: 't.sourceCardTrapScreenReaderText',
    defaultMessage:
      'Navigate menu with tab.  Press escape to close this window and return to the item.',
  },
  menuTrapScreenReaderText: {
    id: 't.menuTrapScreenReaderText',
    defaultMessage:
      'Navigate menu with tab.  Press escape to close this window and return to the header.',
  },
  menuTrapCloseScreenReaderText: {
    id: 't.menuTrapCloseScreenReaderText',
    defaultMessage: 'Close this submenu',
  },
  notYetAuthorizedScreenReaderText: {
    id: 't.notYetAuthorizedScreenReaderText',
    defaultMessage: 'not yet authorized.  Click to authorize posting on your behalf',
  },
  authorizedScreenReaderText: {
    id: 't.authorizedScreenReaderText',
    defaultMessage: 'authorized',
  },
  shortMenuTrapHeaderScreenReaderText: {
    id: 't.shortMenuTrapHeaderScreenReaderText',
    defaultMessage: 'Menu',
  },
  playSourceName: {
    id: 't.playSourceName',
    defaultMessage: 'Play {sourceName}',
  },
  pauseSourceName: {
    id: 't.pauseSourceName',
    defaultMessage: 'Pause {sourceName}',
  },
  filterSearchResults: {
    id: 't.filterSearchResults',
    defaultMessage: 'Filter search results',
  },
  closeModal: {
    id: 't.closeModal',
    defaultMessage: 'Close Modal',
  },
  more: {
    id: 't.more',
    defaultMessage: 'More',
  },
  currentSection: {
    id: 't.currentSection',
    defaultMessage: '(current section)',
  },
});
